export const legalConfig = {
  brandName: 'Alunar Astro',
  legalEntity: 'Zonda Creative LLC',
  brandAttribution: 'Alunar Astro by Zonda Creative LLC',
  entityDescription: 'A Delaware limited liability company',
  jurisdiction: 'State of Delaware, United States',
  country: 'United States',
  addressLine1: '1111B GOVERNORS AVE',
  addressLine2: 'STE 37778',
  city: 'DOVER',
  state: 'DE',
  postalCode: '19904',
  contactEmail: 'support@alunarastro.com',
  effectiveDate: 'August 5, 2026',
  lastUpdated: 'September 15, 2026',
} as const;

export const legalAddressLines = [
  legalConfig.addressLine1,
  legalConfig.addressLine2,
  `${legalConfig.city}, ${legalConfig.state} ${legalConfig.postalCode}`,
  legalConfig.country.toUpperCase(),
] as const;
